module.exports = __webpack_public_path__ + "img/ads.a8224f2.png";